import Vue from 'vue';
import Router from 'vue-router';
import AWN from 'awesome-notifications';
import { checkAuthorization, removeAuthorization } from '@/services/auth';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false });
let notifier = new AWN({ position: 'top-right' });
Vue.use(Router);

const routes = [
    {
        path: '/2fa-query',
        name: '2fa',
        meta: { label: '2FA', requiresAuth: true },
        component: () => import(/* webpackChunkName: "index" */ '@/views/2FA/Index.vue'),
    },
    {
        path: '/2fa-query/login/:app_key',
        name: 'Login',
        component: () => import(/* webpackChunkName: "Login" */ '@/views/pages/Login.vue'),
    },
    {
        path: '/2fa-query/login',
        name: 'Login_noKey',
        component: () => import(/* webpackChunkName: "Login" */ '@/views/pages/Login.vue'),
    },
    {
        path: '/2fa-query/404',
        name: '404',
        component: () => import(/* webpackChunkName: "Error" */ '@/views/pages/Page404.vue'),
    },
    {
        path: '/2fa-query/500',
        name: '500',
        component: () => import(/* webpackChunkName: "component-error" */ '@/views/pages/Page500.vue'),
    },
    { path: '/*', redirect: '/2fa-query/404' },
];

const router = new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'active',
    scrollBehavior: () => ({ y: 0 }),
    routes,
});

router.beforeEach(async (to, from, next) => {
    // 如果 router 轉跳的頁面需要驗證 requiresAuth: true
    NProgress.start();
    if (to.matched.some(record => record.meta.requiresAuth)) {
        let [checkLogin, result] = await checkAuthorization();
        if (checkLogin) {
            next();
        } else {
            removeAuthorization();
            notifier.warning('您的憑證已過期或者憑證異常, 請重新登入！');
            next({ path: '/2fa-query/login/' });
        }
    } else {
        next(); // 往下繼續執行
    }
});

router.afterEach(() => {
    NProgress.done();
});

export default router;
